import { Switch } from "react-router";
import { BrowserRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { ComponentAppRoute, ComponentToast } from "@components";
import { routes } from "@configs";
import { IRoute } from "@interfaces";
import { useWindowDimensions } from "@utils";
import { getInfo, logout, selectAuth, setLoading, setMobile } from "@redux";

export const ModuleMain = () => {
    //page hooks
    const { width } = useWindowDimensions();
    const dispatch = useDispatch();
    //redux states
    const auth = useSelector(selectAuth).auth;

    useEffect(() => {
        dispatch(setMobile(width < 992));
    }, [width]);

    useEffect(() => {
        fetchInfo();
    }, [auth]);

    const fetchInfo = async () => {
        if (auth?.accessToken) {
            try {
                await dispatch(getInfo());
            } catch {
                dispatch(logout());
            } finally {
                dispatch(setLoading(false));
            }
        }
    };

    return (
        <BrowserRouter>
            <Switch>
                {routes.map((e: IRoute, key) => (
                    <ComponentAppRoute key={key} {...e} />
                ))}
            </Switch>
            <ComponentToast />
        </BrowserRouter>
    );
};
